// extracted by mini-css-extract-plugin
export default {"linkAPlan":"_2f9iMPlH-cc27SXaXEiYZ-"};